export class DocumentImagePostType {
  ParentId: string;
  ParentObjectType: string;
  Designation: string;
  Object: string;
  Date: Date;
  Kind: Documentkind;
  constructor(data: any) {
    Object.assign(this, data);
  }
}

export enum Documentkind {
  Dokument = 'Doc',
  Datei = 'FILE',
  Feststellungsbescheid = 'FSB',
  Genehmigung = 'GEN',
  Bild = 'IMAGE',
  Verknüpfung = 'LINK',
  Dateipfad = 'PATH',
  Video = 'VIDEO',
  Wasserrechtsbescheid = 'WRB',
}

export enum GalleryButtons {
  Kamera = 'Kamera',
  Galerie = 'Galerie',
  Abbrechen = 'Abbrechen',
  Datei = 'Dateien',
}

export enum MimeType {
  JPEG = 'jpg',
  PNG = 'png',
  GIF = 'gif',
  PSD = 'psd',
  EPS = 'eps',
}
